import { fetchZendeskProperties } from '../../routines/integrations/zendeskRoutines';

const initialState = {
  organizationProperties: [],
  userProperties: [],
  ticketProperties: [],
  propertyFetchLoading: true,
  error: false,
};

const zendeskPropertyReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchZendeskProperties.TRIGGER:
      return {
        ...state,
        propertyFetchLoading: true,
        error: null,
      };

    case fetchZendeskProperties.SUCCESS: {
      const { organizationProperties, userProperties, ticketProperties } =
        action.payload;
      return {
        ...state,
        propertyFetchLoading: false,
        organizationProperties,
        userProperties,
        ticketProperties,
      };
    }
    default:
      return state;
  }
};

export default zendeskPropertyReducer;
